import React from 'react'; 
import { SingleFormLabel } from '../validation/Form-Components';
 
const LOInstructions = () => {
 
    return(
        <div>
            <SingleFormLabel
                labelId={'lblLOTxt'} 
                labelName={'Our dedicated sales personnel will contact you for the signing of Letter of Offer (LO). Please take note that the disbursement process will start once the LO acceptance is completed.'}/>
        </div>
    )
}

export default LOInstructions;